import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';

/**
 * Set up on day one rather than retrofitted: an ICU-shaped string like
 * "Fifteen for {{points}}" cannot be reconstructed from concatenated fragments
 * later, and score callouts are the most-repeated text in the game.
 */
void i18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
